/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Request to create an S3 Access Point for Redshift access to a vault. 
*/
export class CreateRedshiftAccessPointRequest {
  /**
  * ID of the vault to create the access point for.
  */
  'vaultId': string;
  /**
  * ARN of the IAM role used by the Redshift cluster.
  */
  'redshiftRoleArn': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "redshiftRoleArn",
      "baseName": "redshiftRoleArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateRedshiftAccessPointRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

